<template>
  <section class="figure">
    <div class="plotly_figure" ref='plotly_figure'>
      
    </div>
  </section>
</template>

<style scoped>
  
</style>

<script>
import Plotly from 'plotly.js/dist/plotly';
// var numeral = require('numeral');

export default {
  name: 'PlotlyFigure',
  components: {

  },
  props: [
    'plot_data',
    'pricing',
    'layout',
    'options',
    // 'key', # Used to rerender
  ],
  data: function(){
    return {
      
    };
  },
  computed:{
    
  },
  created: function(){
    
  },
  mounted: function(){ 
    Plotly.newPlot(this.$refs['plotly_figure'], this.plot_data, this.layout, this.options);
    let this_vue = this
    this.$refs['plotly_figure'].on('plotly_click', function(data){
        this_vue.$emit('plot_click', data)
    });
  },
  // watch: {
  //   plot_data: {
  //     handler: function() {
  //       Plotly.react(
  //         this.$refs['plotly_figure'],
  //         this.plot_data,
  //         this.layout, 
  //         this.options
  //       );
  //     },
  //     deep: true
  //   }
  // },
  methods: {

  }
};

</script>
